import { useEffect, useState } from "react";
import { Cpu, UserRound } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api } from "@/lib/api";
import { CodeBarre } from "./CodeBarre";
import { HistoriqueScan } from "./HistoriqueScan";
import { StatutBadge, fmtDateHeure, nomChauffeur } from "./common";

/** Fiche d'une scan remise (clic sur une scan attribuée) : chauffeur, tournée,
 * matériel, code-barres de la tournée et historique de la scan. */
export function FicheScanDialog({ scan, onClose }) {
  const [codes, setCodes] = useState({});
  useEffect(() => {
    if (!scan) return;
    api.get("/scans/codes-barres").then(({ data }) => setCodes(data || {})).catch(() => {});
  }, [scan]);
  const a = scan?.attribution;
  const tournee = a?.tournee || scan?.tournee_defaut;
  const materiel = a?.appareil?.numero_serie || scan?.appareil?.numero_serie;
  return (
    <Dialog open={!!scan} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="sm:max-w-xl max-h-[92dvh] overflow-y-auto" data-testid="fiche-scan">
        <DialogHeader>
          <DialogTitle className="flex flex-wrap items-center gap-2">
            Scan {scan?.numero}{materiel && <span className="font-mono text-base text-muted-foreground">n° {materiel}</span>}
            {scan && <StatutBadge statut={scan.statut} label={scan.statut_label} />}
          </DialogTitle>
          <DialogDescription>
            {a?.chauffeur
              ? <span className="inline-flex flex-wrap items-center gap-1"><UserRound size={13} /> {nomChauffeur(a.chauffeur)}{tournee ? ` · tournée ${tournee}` : ""}{a.signe_le ? ` · remise le ${fmtDateHeure(a.signe_le)} par ${a.signe_par?.nom || "—"}` : ""}</span>
              : "Pas de remise en cours."}
          </DialogDescription>
        </DialogHeader>
        {materiel && <p className="text-sm flex items-center gap-1.5"><Cpu size={14} /> Matériel remis : <span className="font-mono font-semibold" data-testid="fiche-scan-materiel">{materiel}</span></p>}
        {tournee && codes[tournee] ? (
          <div className="rounded-lg border border-border bg-white p-2 text-center" data-testid="fiche-scan-code-barre">
            <p className="text-xs font-semibold text-neutral-700 mb-1">Code-barres de la tournée {tournee}</p>
            <CodeBarre valeur={codes[tournee]} hauteur={80} largeur={2} className="mx-auto" />
          </div>
        ) : tournee ? <p className="text-xs text-muted-foreground">Pas de code-barres pour la tournée {tournee} (Config scan › Codes-barres des tournées).</p> : null}
        <div>
          <p className="text-sm font-semibold mb-2">Historique de la scan</p>
          {scan && <HistoriqueScan scanId={scan.id} />}
        </div>
      </DialogContent>
    </Dialog>
  );
}
